import { Navigate, useRoutes } from 'react-router-dom';

// pages
import HomePage from '../pages/home';
import LoginPage from '../pages/auth/login';
import VerificationPage from '../pages/auth/verification';
import ForgotPasswordPage from '../pages/auth/forgotPassword';
import PasswordResetMailSuccess from '../pages/auth/passwordResetMailSuccess';
import Page404 from '../pages/pageNotFound';
import ContactUsPage from '../pages/contactUs';
import AboutUs from '../pages/aboutUs/aboutUs';
import GlobalPresence from '../pages/aboutUs/globalPresence';
import InvestmentsPage from '../pages/investments';
import ObjectivesPage from '../pages/objectivesPage';
// import IndividualProject from '../pages/projectsPage/herClubProject';
// import ProjectDetailPage from '../pages/projectsPage/projectDetailPage/WaterProjectDetail';
import ProjectPage from '../pages/projectsPage';
import JoinOurCommunityPage from '../pages/joinOurCommunity';
import LatestArticles from '../pages/articlesPage/latestArticles';
import IndividualArticles from '../pages/articlesPage/individualArticles';
import HerClubProject from '../pages/projectsPage/herClubProject';
import WaterProject from '../pages/projectsPage/waterProject';
import WaterProjectDetail from '../pages/projectsPage/projectDetailPage/WaterProjectDetail';
import HerClubDetailPage from '../pages/projectsPage/projectDetailPage/herClubDetailPage';
import ComingSoon from '../pages/pageNotFound/comingSoon';
import RegisterPage from '../pages/auth/register';
import IndividualInvestments from '../pages/investments/individualInvestments';


// ----------------------------------------------------------------------

export default function Router() {
  const isLoggedIn = window.localStorage.getItem('temp-token');
  const routes = [
    {
      path: '/',
      element: <HomePage />,
    },
    {
      path: 'contact-us',
      element: <ContactUsPage />,
    },
    {
      path: 'about-us',
      element: <AboutUs />,
    },
    {
      path: 'global-presence',
      element: <GlobalPresence />,
    },
    {
      path: 'investments',
      element: <InvestmentsPage />,
    },
    {
      path: 'investments-details/:id',
      element: <IndividualInvestments />
    },
    {
      path: 'objectives',
      element: <ObjectivesPage />,
    },
    {
      path: 'join-our-community',
      element: <JoinOurCommunityPage />
    },
    {
      path: 'latest-articles',
      element: <LatestArticles />
    },
    {
      path: 'individual-articles/:id',
      element: <IndividualArticles />
    },
    {
      path: '404',
      element: <Page404 />,
    },
    {
      path: '/projects',
      children: [
        { element: <ProjectPage />, index: true },
        { path: 'empowering-women', element: <HerClubProject />, index: true },
        { path: 'sustainable-water-energy-solution', element: <WaterProject />, index: true },
        { path: 'water-project-details', element: <WaterProjectDetail />, index: true },
        { path: 'her-cub-details', element: <HerClubDetailPage />, index: true },
      ],
    },
    {
      path: 'auth',
      children: [
        { element: <Navigate to="login" />, index: true },
        { path:'register', element: <RegisterPage /> },        
        { path: 'login', element: <LoginPage /> },
        { path:'verification', element: <VerificationPage /> },
        {path: 'forgot-password', element: <ForgotPasswordPage />},
        {path: 'reset-password-email-sent', element: <PasswordResetMailSuccess />}
        // {path: 'reset-password', element: <ResetPassword />}
      ]
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
    {
      path: 'coming-soon', 
      element: <ComingSoon />
    },
  ];

  const privateRoutes = isLoggedIn ? [
    {
      path: '/sample',
      children: [
        { element: <Navigate to="/sample/list" />, index: true },
        { path: 'list', element: <HomePage /> },
      ],
    },
  ] : [];

  return useRoutes(routes.concat(privateRoutes));
}
